<div mat-dialog-title>
  <span>{{ 'POPUPS.AUTHORISATION_REJECT' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">
  {{ error | translate }}
</q9-info-message>

<mat-dialog-content>
  <form [formGroup]="form" #formTemplate="ngForm" class="form-content">
    <q9-textarea-field
      formControlName="reason"
      [minRows]="3"
      [maxRows]="10"
      [label]="'POPUPS.AUTHORISATION_REJECT_REASON'"></q9-textarea-field>
    <q9-text-field
      *ngIf="havePassword"
      formControlName="password"
      type="password"
      [label]="'POPUPS.ENTER_PASSWORD'"></q9-text-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'VERSIONING.CANCEL_BTN' | translate }}
  </q9-secondary-button>
  <q9-primary-button [isLoading]="isLoading()" (click)="formTemplate.onSubmit($event); onSubmit()">
    {{ 'VERSIONING.REJECT' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
